// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"260":"publishers","687":"agenda","797":"event","962":"home"}[chunkId] + "." + {"260":"b8878f35","687":"75af48df","797":"0d2a3aad","962":"180d3e0a"}[chunkId] + ".js";
};